require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-jsiebern-bs-devextreme-reactive.json") })
        }
      }, "path---package-jsiebern-bs-devextreme-reactive");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-jsiebern-bs-devextreme-reactive!./.cache/json/package-jsiebern-bs-devextreme-reactive.json
// module id = 872
// module chunks = 231608221292675